/* eslint-disable max-len */
import React from 'react'; // { useEffect, useState }
import { FaTimes, FaCheck } from 'react-icons/fa';
// import useTranslation from '../../hooks/useTranslation';
import EpButton from '../EpButton';
import EpModal, { handleToggleModalWithGlobalState } from '../EpModal';
import useTranslation from '../../hooks/useTranslation';
import './styles.scss';

export default function EpBrowserModal() {
  const YourWebBrowserIsOutOfDate = useTranslation('Your web browser is out of date!');
  const UpdateYourBrowserForMoreSecuritySpeedAndTheBestExperienceOnThisSite = useTranslation('Update your browser for more security, speed and the best experience on this site.');
  const Warning = useTranslation('Warning');
  const Cancel = useTranslation('Cancel');
  const UpdateBrowser = useTranslation('Update browser');

  const headerTitle = (
    <span className="modal-browser-title">{Warning}</span>
  );

  const redirectBrowser = () => {
    window.open('https://bestvpn.org/outdatedbrowser/', '_blank');
  };

  const bodyContent = (
    <div className="modal-browser__content">
      <span className="modal-browser__content-alert">{YourWebBrowserIsOutOfDate}</span>
      <p className="modal-browser__content-text">
        {UpdateYourBrowserForMoreSecuritySpeedAndTheBestExperienceOnThisSite}
      </p>
      <EpButton
        actionType="button"
        labelText={UpdateBrowser}
        linkFunc={() => redirectBrowser()}
        buttonType="primary-outline"
        buttonIcon={<FaCheck className="btn__icon" />}
        disabled={false}
        size="lg"
      />
    </div>
  );

  const footerContent = (
    <EpButton
      actionType="button"
      labelText={Cancel}
      linkFunc={
        () => handleToggleModalWithGlobalState('modal--browser-notification', 'IE_COMPATIBILITY', false)
      }
      buttonType="secondary-outline"
      buttonIcon={<FaTimes className="btn__icon" />}
      customClass="btn__footer"
      disabled={false}
      size="sm"
    />
  );

  return (
    <EpModal
      modalId="modal--browser-notification"
      modalType="IE_COMPATIBILITY"
      modalOptions={{ backdrop: 'static' }}
      headerTitle={headerTitle}
      bodyContent={bodyContent}
      footerContent={footerContent}
      size="sm"
      alignFooter="justify-content-center"
    />
  );
}
